import {
    NestedField,
} from 'app/types/form.types'
import {
    Timezone,
    RegionFirstLevel,
} from 'app/enums/label.enums'

import {
    LocationFormFields,
} from '../LocationForm.types'

export const getAirportFieldDetails = ({
    timeZones, country, getAllowedValues,
}): NestedField<LocationFormFields>[] => {
    return [
        {
            name: 'iataCode',
            required: true,
            componentName: 'InputSingleline',
            labelKey: 'IATA_CODE',
        },
        {
            componentName: 'CitySuggestions',
            name: 'city',
            timeZones,
            required: true,
            labelKey: 'CITY',
        },
        {
            name: 'country',
            componentName: 'CountryDataSelector',
            value: country,
            labelKey: 'COUNTRY',
        },
        {
            name: 'state',
            country: country?.id,
            componentName: 'StateSelector',
            labelKey: 'STATE',
        },
        {
            name: 'timeZone',
            componentName: 'EnumSelector',
            allowedValues: getAllowedValues(Timezone),
            required: true,
            labelKey: 'TIME_ZONE',
        },
        {
            name: 'zip',
            componentName: 'InputSingleline',
            labelKey: 'ZIP_CODE',
        },
        {
            name: 'region',
            componentName: 'EnumSelector',
            allowedValues: getAllowedValues(RegionFirstLevel),
            required: true,
            labelKey: 'REGION',
        },
    ]
}
export default getAirportFieldDetails
